module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epi-1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Eternal Father, strong to save,")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "epi-2"
  }, [_vm._v("Whose arm hath bound the restless wave,")]), _vm._v(" "), _c('p', {
    staticClass: "epi-2"
  }, [_vm._v("Who bidd’st the mighty ocean deep")]), _vm._v(" "), _c('p', {
    staticClass: "epi-2"
  }, [_vm._v("Its own appointed limits keep;")]), _vm._v(" "), _c('p', {
    staticClass: "epi-2"
  }, [_vm._v("Oh, hear us when we cry to Thee,")]), _vm._v(" "), _c('p', {
    staticClass: "epi-2"
  }, [_vm._v("For those in peril on the sea!")])]), _c('p', {
    staticClass: "epi-3"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Navy Hymn")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0